var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "email-edit-form",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.submit($event)
        }
      }
    },
    [
      _c("div", { staticClass: "email-edit-form__title" }, [
        _vm._v("\n    Изменение Email\n  ")
      ]),
      _c(
        "div",
        { staticClass: "email-edit-form__wrap" },
        [
          _c("ui-input", {
            staticClass: "email-edit-form__input",
            attrs: {
              clearable: "",
              validate: "email",
              label: "Новый Email*",
              placeholder: "Введите Email",
              error: _vm.mailError
            },
            on: { "is-valid": _vm.onIsValid },
            model: {
              value: _vm.email,
              callback: function($$v) {
                _vm.email = $$v
              },
              expression: "email"
            }
          }),
          _c("ui-button", {
            ref: "submit",
            staticClass: "email-edit-form__submit",
            attrs: {
              wide: "",
              type: "submit",
              loading: _vm.isLoading,
              disabled: !_vm.isMailValid,
              text: "Изменить"
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }